import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=2bef7408"
import script from "./GlobalLayout.vue?vue&type=script&lang=ts"
export * from "./GlobalLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports